import type * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LuminaireJournalByIdFromLightingIoTQueryVariables = Types.Exact<{
  input: Types.LightingIoT_GetLuminaireJournalByIdInput;
}>;


export type LuminaireJournalByIdFromLightingIoTQuery = { __typename?: 'Query', LightingIoT_luminaireJournalById: { __typename?: 'LightingIoT_GetLuminaireJournalByIdPayload', journal?: { __typename?: 'LightingIoT_LuminaireJournalModel', id: any, version: number, created: any, changed: any, luminaireId: any, areaId: any, status: { __typename?: 'LightingIoT_LuminaireJournalStatusModel', communicationDate?: any | null, energyMeteringDate?: any | null, signalStrength?: number | null, signalToNoiseRatio?: number | null, temperature?: number | null, consumption?: number | null, powerFactor?: number | null, voltage?: number | null }, dailySummary: { __typename?: 'LightingIoT_LuminaireJournalSummaryModel', id: any, range: Types.LightingIoT_LuminaireJournalSummaryRangeModel, items: Array<{ __typename?: 'LightingIoT_LuminaireJournalSummaryItemModel', id: any, date: any, type: Types.LightingIoT_LuminaireJournalSummaryItemTypeModel, energyConsumption?: { __typename?: 'LightingIoT_LuminaireJournalSummaryItemEnergyConsumptionSectionModel', consumedEnergy: number, minCurrentEnergy?: number | null, maxCurrentEnergy?: number | null, minPowerFactor?: number | null, maxPowerFactor?: number | null, minVoltage?: number | null, maxVoltage?: number | null } | null, workTime?: { __typename?: 'LightingIoT_LuminaireJournalSummaryItemWorkTimeSectionModel', operatingTime: any } | null }> }, monthlySummary: { __typename?: 'LightingIoT_LuminaireJournalSummaryModel', id: any, range: Types.LightingIoT_LuminaireJournalSummaryRangeModel, items: Array<{ __typename?: 'LightingIoT_LuminaireJournalSummaryItemModel', id: any, date: any, type: Types.LightingIoT_LuminaireJournalSummaryItemTypeModel, energyConsumption?: { __typename?: 'LightingIoT_LuminaireJournalSummaryItemEnergyConsumptionSectionModel', consumedEnergy: number, minCurrentEnergy?: number | null, maxCurrentEnergy?: number | null, minPowerFactor?: number | null, maxPowerFactor?: number | null, minVoltage?: number | null, maxVoltage?: number | null } | null, workTime?: { __typename?: 'LightingIoT_LuminaireJournalSummaryItemWorkTimeSectionModel', operatingTime: any } | null }> } } | null } };


export const LuminaireJournalByIdFromLightingIoTDocument = gql`
    query luminaireJournalByIdFromLightingIoT($input: LightingIoT_GetLuminaireJournalByIdInput!) {
  LightingIoT_luminaireJournalById(input: $input) {
    journal {
      id
      version
      created
      changed
      luminaireId
      areaId
      status {
        communicationDate
        energyMeteringDate
        signalStrength
        signalToNoiseRatio
        temperature
        consumption
        powerFactor
        voltage
      }
      dailySummary {
        id
        range
        items {
          id
          date
          type
          energyConsumption {
            consumedEnergy
            minCurrentEnergy
            maxCurrentEnergy
            minPowerFactor
            maxPowerFactor
            minVoltage
            maxVoltage
          }
          workTime {
            operatingTime
          }
        }
      }
      monthlySummary {
        id
        range
        items {
          id
          date
          type
          energyConsumption {
            consumedEnergy
            minCurrentEnergy
            maxCurrentEnergy
            minPowerFactor
            maxPowerFactor
            minVoltage
            maxVoltage
          }
          workTime {
            operatingTime
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLuminaireJournalByIdFromLightingIoTQuery__
 *
 * To run a query within a React component, call `useLuminaireJournalByIdFromLightingIoTQuery` and pass it any options that fit your needs.
 * When your component renders, `useLuminaireJournalByIdFromLightingIoTQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLuminaireJournalByIdFromLightingIoTQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLuminaireJournalByIdFromLightingIoTQuery(baseOptions: Apollo.QueryHookOptions<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables> & ({ variables: LuminaireJournalByIdFromLightingIoTQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables>(LuminaireJournalByIdFromLightingIoTDocument, options);
      }
export function useLuminaireJournalByIdFromLightingIoTLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables>(LuminaireJournalByIdFromLightingIoTDocument, options);
        }
export function useLuminaireJournalByIdFromLightingIoTSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables>(LuminaireJournalByIdFromLightingIoTDocument, options);
        }
export type LuminaireJournalByIdFromLightingIoTQueryHookResult = ReturnType<typeof useLuminaireJournalByIdFromLightingIoTQuery>;
export type LuminaireJournalByIdFromLightingIoTLazyQueryHookResult = ReturnType<typeof useLuminaireJournalByIdFromLightingIoTLazyQuery>;
export type LuminaireJournalByIdFromLightingIoTSuspenseQueryHookResult = ReturnType<typeof useLuminaireJournalByIdFromLightingIoTSuspenseQuery>;
export type LuminaireJournalByIdFromLightingIoTQueryResult = Apollo.QueryResult<LuminaireJournalByIdFromLightingIoTQuery, LuminaireJournalByIdFromLightingIoTQueryVariables>;